<template>
<div class="app-logo">
  <img  v-if="iconLogo" src="@/assets/images/logo-white-icon.png" alt="Logo" class="w-6 h-6" />
  <img v-else src="@/assets/images/logo-white.png" alt="Logo" class="max-w-full h-8" />
</div>
</template>

<script lang="ts" setup>
defineProps({
  iconLogo: {
    type: Boolean,
    default: false
  }
})
</script>
